import SVG from "../SVG";

export default function Select({
  options = [], // array of option labels (strings)
  className = "", // extra classes from parent
  selectClassName = "", // extra classes for the select element
  showFocusRing = true,
  name,
  id,
  value,
  onChange,
  placeholder = "انتخاب کنید", // static first option text
}) {
  const allOptions = [placeholder, ...options];

  const selectProps = {
    id,
    name,
    onChange,
    className:
      "w-full appearance-none bg-transparent border border-zi-border-dark " +
      "rounded-lg py-1 px-2.5 text-base font-normal text-zi-text-light dark:text-zi-text-dark " +
      `outline-none ${showFocusRing ? "hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark" : "ring-0"} ` +
      `bg-zi-bg2-light dark:bg-zi-bg2-dark cursor-pointer ${selectClassName}`,
    defaultValue: "",
  };

  // If a value prop is provided, make it a controlled select
  if (value !== undefined) {
    delete selectProps.defaultValue;
    selectProps.value = value;
  }

  return (
    <div className={`relative inline-flex items-center w-full ${className}`}>
      <select {...selectProps}>
        {allOptions.map((opt, index) => (
          <option
            key={index}
            value={index === 0 ? "" : opt}
            disabled={index === 0}
            className="text-zi-text-light"
          >
            {opt}
          </option>
        ))}
      </select>

      {/* Custom select arrow icon (replaces browser default) */}
      <div className="pointer-events-none absolute left-3 flex items-center">
        <SVG
          name="select"
          classname="size-3 stroke-zi-text-light dark:stroke-zi-text-dark"
        />
      </div>
    </div>
  );
}
